import { StandardEvents } from '@shopify/events';
import { publish, readAnalyticsItems, resolveListId } from '@theme/analytics';

/**
 * Every `<product-card>`/`<product-component>` already dispatches shopify:product:view
 * once it enters the viewport (see assets/view-event-elements.js). The first card of a
 * given `[data-analytics-list-name]` container to fire that event is the signal that the
 * whole list became visible — publish view_item_list once per container, per page view,
 * covering every list already rendered inside it (not just the visible card).
 */
const publishedLists = new WeakSet();

document.addEventListener(StandardEvents.productView, (event) => {
  if (!(event.target instanceof Element)) return;

  const container = event.target.closest('[data-analytics-list-name]');
  if (!(container instanceof HTMLElement) || publishedLists.has(container)) return;
  publishedLists.add(container);

  const items = readAnalyticsItems(container);

  if (items.length) {
    publish('view_item_list', {
      item_list_id: resolveListId(container),
      item_list_name: container.dataset.analyticsListName,
      items,
    });
  }
});
